<div class="loading-screen d-flex flex-column justify-content-center align-items-center">
  @if (error) {
    @if (accessDenied) {
      <h2 class="h5 mb-3">Access denied</h2>
    }
    <p role="alert" class="text-center px-3">{{ error }}</p>
    <button type="button" class="btn btn-primary d-flex align-items-center" (click)="retry.emit()">
      <mat-icon aria-hidden="true">refresh</mat-icon> Try again
    </button>
    @if (accessDenied) {
      <button type="button" class="btn btn-outline-secondary d-flex align-items-center mt-3" (click)="signOut.emit()">
        <mat-icon aria-hidden="true">logout</mat-icon> Return to sign in
      </button>
    }
  } @else {
    <mat-spinner mode="indeterminate" color="primary"></mat-spinner>
  }
</div>
